if (typeof window !== "undefined") {
  const globalWindow = window as Window & { process?: { env?: Record<string, string | undefined> } };
  if (!globalWindow.process) {
    globalWindow.process = { env: {} };
  } else if (!globalWindow.process.env) {
    globalWindow.process.env = {};
  }
}

export {};
